import { BenchmarkPeriodOption } from 'app/hub-components/components/benchmarks/benchmarks.component';

export const RESULTS_PER_PAGE_OPTIONS = [10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100];
export const DEFAULT_RESULTS_PER_PAGE = 10;
export const BENCHMARK_OPTIONS: BenchmarkPeriodOption[] = [
  { name: 'None', value: 'none' },
  { name: 'Previous Period', value: 'previous_period' },
  { name: 'Previous Year', value: 'previous_year' },
  { name: 'Custom period', value: 'custom' },
];

export const DEFAULT_BENCHMARK_OPTION: BenchmarkPeriodOption = { name: 'None', value: 'none' };

